const LOCK_CLASS = 'scroll-locked';
let lockCount = 0;

export function lockBodyScroll() {
	if(lockCount === 0) {
		document.documentElement.classList.add(LOCK_CLASS);
	}
	lockCount++;
}

export function unlockBodyScroll() {
	if(lockCount === 0) return;
	lockCount--;
	if(lockCount === 0) {
		document.documentElement.classList.remove(LOCK_CLASS);
	}
}
